// var dCPendingList = [] // 保存查询字符串，需要加上问号拼成完整字符串，_ac_type=1&_uniq_key=123.....

// var dCSendingImg = new Image()

// var sendingDC = false

let sdk = require("clover/dc/clover_h5_js");

function convert2Str(v) {
    return v? v.toString(): "";
}
function getQueryString(params) {
    var arr = []
    for (var name in params) {
        var value = params[name]
        arr.push(encodeURIComponent(name) + '=' + encodeURIComponent(value))
    }
    return arr.join('&')
}

// sdk文件clover_h5_js通过npm run dc-sdk自动生成
// schema sdk打点的所有value都必须转成字符串，包括嵌套的json内的值。extractMap必须是一个json字符串。
function getSchemaParam(params){
    console.log("-------------------------schema sdk-------------------------");
    var logMap = new sdk.Map();
    var extractMap = new sdk.Map();
    var acTypeOld = "";
    var acTypeNew = "";
    for (var name in params) {
        if (name == "_ac_type"){
            acTypeOld = convert2Str(params[name]);
            acTypeNew = sdk.getNewAcType(acTypeOld);
            logMap.set("_ac_type", acTypeNew);
        }else{
            logMap.set(sdk.getNewAttr(name), params[name]);
            if (name == "extractmap"){
                var extractMaString = params[name].replace(/\\/g, "");
                var extractMapJson = JSON.parse(extractMaString);
                for(var k in extractMapJson){
                    extractMap.set(k, convert2Str(extractMapJson[k]));
                }
            }
        }
    }
    var p = sdk.checkRequest(logMap, extractMap);
    if (p.success){
        var map = {};
        logMap.forEach(function(v, k){
            map[k] = convert2Str(v);
        })
        return map;
    }else{
        if (__DEBUG){
            console.error('dc with schema failed', acTypeOld, acTypeNew, p)
            let msg = string.format("_ac_type:%s(%s) error", acTypeOld, acTypeNew);
            if (window.Toast) {
                Toast.make(msg);
            } else {
                alert(msg);
            }
        }else{

        }
        return null;
    }
}

let _waitToSend = [];
let _scheduleId = 0;
// batch模式无法在dctest上查询到，__DEBUG模式下不开batch
let _disableBatch = __DEBUG //|| window.mini && mini.getPlatform() === MiniPlatform.oppoQuickgame
let interval = 0
function update(dt) {
    interval = interval + dt
    if (interval < 0.5){
        return
    }
    interval = 0
    if (_waitToSend.length > 0) {
        let ary = Array.from(_waitToSend);
        _waitToSend.length = 0;

        fire(ary);
    } else {
        if (_scheduleId) {
            cc.director.getScheduler().unscheduleScriptEntry(_scheduleId);
            _scheduleId = 0;
        }
    }
}
function reload(param) {
    _waitToSend.push(param);

    if (_disableBatch || !window.cc || window.cc.game.isPaused()) {
        // cocos未启动/暂停时，直接发送
        let ary = Array.from(_waitToSend);
        _waitToSend.length = 0;

        fire(ary);
    } else {
        if (!_scheduleId)
            _scheduleId = cc.director.getScheduler().scheduleScriptFunc(update, 0, false);
    }
}

function fire(dcList) {
    if (!dcList || dcList.length == 0)
        return;

    let param = null;
    if (dcList.length == 1) {
        param = getQueryString(dcList[0]);
    } else {
        let str = JSON.stringify(dcList);
        param = "_uniq_key=clover_h5cn_prod&_user_id="+dcList[0]["_user_id"]+"&_batch_value=" + he.HeDisplayUtil.urlEncode(str);
    }

    if (!__DEV)
        JustRequest(DC_HOST, true, param);
}

/**
 * 打点相关数据
 */
let _dcData = {
    dcsession_id: randomChar(32),  // 全局DC打点的Session值
    first_ts: 0, // 初次打点时间
};

function sendDCLogSync(params, useSchema = false) {
    if (!_dcData.first_ts)
        _dcData.first_ts = new Date().getTime();


    params = setDCBaseData(params);

    // extractMap只有用schema sdk才能打
    if (!useSchema && params.extractmap){
        useSchema = true;
    }
    if (useSchema) {
        var s = getSchemaParam(params);
        if (s)  reload(s);
    }else{
        reload(params);
    }
    META.seqId++;
}

/**
 * 设置通用打点值
 * @param {*} params
 * @param {Date} 当前时间，可以为空
 * @return {number} now 当前设备时间戳
 */
function setDCBaseData(params) {
    let userId = window.UserManager && UserManager.hasInstance() && UserManager.getInstance().uid || META.user.openid || "1"
    if (typeof(userId) == "string"){
        userId = userId.replace(".", "")    // 抖音openid可能带有"."导致入库报错，这里直接去掉
    }
    let baseMap = {
        _uniq_key: "clover_h5cn_prod",
        _user_id: userId,
        gid: window.UserManager && UserManager.hasInstance() && UserManager.getInstance().uid || "1",
        dcsession_id: _dcData.dcsession_id,
        seq_id: META.seqId,
        platform: window.mini? mini.getPlatform(): META.user.platform,
        partition: "h5",
        server: "h5",
        gameversion: META.version
    }

    return Object.assign(baseMap, params);
}

let dc4UserLoad = (function() {
    let lastStep = 0;
    let firstLoadTimestamp = 0;
    let cachedLaunchOptions = null;
    let installKey = localStorage.getItem("_local_install_key");
    if (!installKey) {
        installKey = window.generateUUID();
        localStorage.setItem("_local_install_key", installKey);
    }

    function func(step) {
        if (step <= lastStep) {
            console.warn("dc4UserLoad cancel. step="+step+" while lastStep="+lastStep);
            return;
        }
        let now = new Date()
        
        if (step == 1)
            firstLoadTimestamp = now.getTime();

        // 尽量保持第一个点位的时间与user_load step=1一致
        if (!_dcData.first_ts)
            _dcData.first_ts = firstLoadTimestamp;

        let params = {
            _ac_type: "user_load",  
            viral_id: _dcData.dcsession_id,
            step: step,
            interval: now.getTime() - firstLoadTimestamp,
            is_new_device: META.is_new_device? "1": "0",
            is_new: (window.UserManager && UserManager.hasInstance())? (window._G.kIsNewUser? "1": "0"): "1",
            time: formatDate(now),
            time_zone: -now.getTimezoneOffset() / 60,
            interval: (now.getTime() -  firstLoadTimestamp).toString(),
            install_key: installKey
        }

        let launchOptions = cachedLaunchOptions || window.getLaunchOptions();
        if (launchOptions.textId) params.textid = launchOptions.textId;
        if (launchOptions.channel) params.src_channel = launchOptions.channel;
        if (launchOptions.src) params.src = launchOptions.src;
        if (launchOptions.inviteCode) params.inviter_id = launchOptions.inviteCode;
        if (launchOptions.wxScene) params.wxscene = launchOptions.wxScene;
        if (launchOptions.channel_id) params.channel_id = launchOptions.channel_id;

        lastStep = step;
        sendDCLogSync(params, true);
    }
    return func
})();

let dc4PreloadSceneLogin = (function() {

    function func(sub_category, params) {
        params._ac_type = "useraction_unknown_category"
        params.category = "optimization"
        params.sub_category = sub_category
        setDCBaseData(params)

        sendDCLogSync(params, true);
    }
    return func
})();

let dcUtil = {
    /**
     * user_load打点
     * @param {number} step
     */
    dc4UserLoad,
    /**
     * 登录界面耗时打点
     */
    dc4PreloadSceneLogin,
    /**
     * 发送打点请求
     * @param {object} param 打点参数
     * @param {boolean} useSchema 是否使用标准打点 
     */
    sendDCLogSync,
    /**
     * 获取打点唯一 Session
     */
    getDCSession: function() {
        return _dcData.dcsession_id;
    },
    /**
     * 获取首个打点时间戳
     */
    getDCStartTime: function() {
        return _dcData.first_ts;
    },

    stealSeq: function() {
        let seq = META.seqId;
        META.seqId++;
        return seq;
    },
    getSchemaClentVersionValue: function() {
        return sdk.getSchemaClentVersionValue();
    }
}

// 打第一个点
dc4UserLoad(1);

module.exports = dcUtil;